/* eslint-disable react/jsx-props-no-spreading */
import { ReactElement } from 'react';
import { Container, Error, Input, Icon, InputLabel, Label, IconCreditCard } from './style';

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  sizeDisplay?: 'lg' | 'md' | 'sm' | 'perso' | 'none';
  error?: boolean;
  errorMessage?: string;
  icon?: ReactElement | null;
  labelTxt?: string;
  haveMargin?: boolean;
  isCreditCard?: boolean;
}

const StyledInput: React.FC<IProps> = ({
  sizeDisplay = 'lg',
  error = false,
  errorMessage = '',
  icon,
  haveMargin = false,
  isCreditCard = false,
  labelTxt,
  ...rest
}) => (
  <Container haveMargin={haveMargin} sizeDisplay={sizeDisplay}>
    {labelTxt && <Label>{labelTxt}</Label>}
    <Input error={error} {...rest} />
    {
      isCreditCard === false ?
      <Icon> {icon}</Icon>
      : <IconCreditCard> {icon}</IconCreditCard>
    }
{ error && errorMessage !== '' && <Error>{errorMessage}</Error> }
{ rest.value && !labelTxt && <InputLabel >{rest.placeholder}</InputLabel> }
  </Container >
);

export { StyledInput };
